import { render, staticRenderFns } from "./_blogArticle.vue?vue&type=template&id=f500c024&"
import script from "./_blogArticle.vue?vue&type=script&lang=js&"
export * from "./_blogArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports